<div style="padding: 15px 5px 5px;">
    <div class="mybtn-success" style="font-size: 1.2rem;" data-dismiss="modal" (click)="novaClanarinaStart()">Unos članarine</div>
</div>